import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { SliderModel } from "../models/dashboard/slider.model";
import { BloccoModel } from "../models/dashboard/blocco.model";
import { BloccoTipoModel } from "../models/dashboard/bloccoTipo.model";
import { RequestModel } from "../models/dashboard/request.model";
import { DriverModel } from "../models/dashboard/driver.model";

@Injectable()
export class SharedService {
  public uvZoneLoaded = new BehaviorSubject<boolean>(false);
  public uvZona = new BehaviorSubject<any>({ uv: "", zona: "" });
  slider: SliderModel;
  tipi: Array<BloccoTipoModel> = [];
  responseTypes: Array<any>;
  blocco: BloccoModel;
  request: RequestModel;
  driver: DriverModel;
  taxonomyTypes: Array<any>;

  constructor() {}

  setSlider(slider: SliderModel) {
    this.slider = slider;
  }
  getSlider(): SliderModel {
    return this.slider;
  }

  setTipi(tipi: Array<BloccoTipoModel>) {
    this.tipi = tipi;
  }
  getTipi() {
    return this.tipi;
  }

  setResponseTypes(responseTypes: Array<any>) {
    this.responseTypes = responseTypes;
  }
  getResponseTypes() {
    return this.responseTypes;
  }

  setTaxonomyTypes(taxonomyTypes: Array<any>) {
    this.taxonomyTypes = taxonomyTypes;
  }
  getTaxonomyTypes() {
    return this.taxonomyTypes;
  }

  setBlocco(blocco: BloccoModel) {
    this.blocco = blocco;
  }

  getBlocco(): BloccoModel {
    return this.blocco;
  }

  setRequest(request: RequestModel) {
    this.request = request;
  }

  getRequest() {
    return this.request;
  }

  setDriver(driver: DriverModel) {
    this.driver = driver;
  }

  getDriver() {
    return this.driver;
  }

  setUvZoneList(loaded: boolean) {
    this.uvZoneLoaded.next(loaded);
  }

  setUVZona(uvZona: any) {
    this.uvZona.next(uvZona);
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/shared.service.ts